// extracted by mini-css-extract-plugin
var _1 = "rUy98L1k";
var _2 = "rUy98L1k";
export { _1 as "skyra-survey", _2 as "skyraSurvey" }
